<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start stretch" >
	<!-- <div fxFlex="3%">
		   <sui-checkbox >
            </sui-checkbox>
	</div> -->
		<div  fxFlex="10%">{{application?.applicationName}}</div>
		<div  fxFlex="15%">{{application?.applicationHost}}</div>
		<div  fxFlex="15%">{{application?.accessTypes}}</div>
		<!-- <div  fxFlex="15%">{{application?.applicationDescription}}</div> -->
		<div  fxFlex="10%"><span class="ui tiny red label" [ngClass]="{'green':application.hideFromDashboard == true}" >{{application?.hideFromDashboard}}</span></div>
		<div  fxFlex="10%">{{application?.dateCreated | date}}</div>
		<div  fxFlex="10%">{{application?.createdBy | createdBy}}</div>
		<div  fxFlex="18%"  class="text-right">
			  <div class="ui  small basic primary dropdown button" suiDropdown >
                <div class="text">Actions</div>
                <i class="dropdown icon"></i>
                <div class="left menu" suiDropdownMenu >
                <div class="item" *isPermitted="{id:'APPLICATIONS_MANAGEMENT',action:'edit'}" (click)="onEdit.emit(application)">Edit Application</div>
				<div class="item" (click)="onShow.emit(application)" *ngIf="application.hideFromDashboard">Show on Dashboard</div>
				<div class="item" (click)="onHide.emit(application)" *ngIf="!application.hideFromDashboard">Hidden from Dashboard</div>
				<div class="item" *isPermitted="{id:'APPLICATIONS_MANAGEMENT',action:'edit'}"(click)="onChangeImage.emit(application)">Change Image</div>
				<div class="item" *isPermitted="{id:'APPLICATIONS_MANAGEMENT',action:'remove'}" (click)="onDelete.emit(application)">Remove Application</div>
                </div>
			</div> &nbsp;
			<button
				class="ui circular tiny button"
				(click)="onView.emit(application)"
				suiPopup
				[popupInverted]="true"
				popupPlacement="bottom"
				popupText="View Details"
			><i class="eye icon"></i></button>

		</div>
</div>